import { GenericModelApi } from "./GenericModelApi";
import { ProductlogFormData } from "@/formTypes/ProductlogFormDataType";
import { getTenantId, getUserData } from "@utils/Auth";
import { ApiSchema, ApiError, FetchResponse } from "@/api/ApiClient";

export type ProductlogDataType = Partial<ApiSchema["Productlog"]["type"] & ProductlogFormData>;
class Api extends GenericModelApi<"Productlog", ProductlogDataType> {

    async createProductLog(previousAmount: number, changeAmount: number, newAmount: number, productId: string, comments: string = ""): Promise<ProductlogDataType> {
        const { email: userEmail, name = "" } = await getUserData()
        const log: ProductlogDataType = {
            previous_amount: previousAmount,
            change_amount: changeAmount,
            new_amount: newAmount,
            comments,
            productId,
            user: name || userEmail
        }
        return await this.create(log)
    }

    async getMovementByProduct(
        productId: string,
    ): Promise<FetchResponse<ProductlogDataType>> {
        const tenantId = await getTenantId();

        const fetchFunction = this.model.listProductlogByTenant;
        const { data, errors, nextToken: nt } = await fetchFunction({
            owner: tenantId,
            productIdCreatedAt: {
                beginsWith: {
                    productId,
                    createdAt: ""
                }
            }
        }, {
            limit: 100,
            sortDirection: "DESC"
        });

        if (errors) {
            throw new ApiError("Error al obtener el product por codigo", "API_ERROR", errors);
        }

        return {
            items: data,
            nextToken: nt
        }
    }
}
export const ProductlogApi = new Api("Productlog", "createdAt")